import { TFunction } from 'i18next'

import { QuoteStatus } from '@features/invoices/enums/quoteStatus'

export const getQuoteStatusLabel = (status: QuoteStatus, t: TFunction): string => {
  switch (status) {
    case QuoteStatus.Accepted:
      return t('quotes.view.sidebar.status.accepted')
    case QuoteStatus.Rejected:
      return t('quotes.view.sidebar.status.rejected')
    case QuoteStatus.Invoiced:
      return t('quotes.view.sidebar.status.invoiced')
    case QuoteStatus.Deleted:
      return t('quotes.view.sidebar.status.deleted')
    case QuoteStatus.Created:
    case QuoteStatus.Sent:
    case QuoteStatus.Open:
    case QuoteStatus.Unsent:
      return t('quotes.view.sidebar.status.open')
  }
}
